module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAACZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrWZqrVI+sstAAAAEXRSTlMAEL//ADDvgGDP348gn1CvQNBu8dwAAAEOSURBVHgB7dPNbsMgEMTxwAy7xh+k7/+0kdIUxy1EIPZSif9ppJV+Mgff3nMe8I4kSysXPABRXrrxLQ8AvrJyC76LdQjPyisX8JMOQW7NkAxBG85GoB1G0GEE7TCCNitIjKAEI2izglYjaIcRlKwgtYK8FRStIPx3aC+vAuQ+Q4lM5xr4ophSvK5+qFontKLS2gkdqHR0QgsqLZ2/CAXFhL3QhmLKzr+fTlBIXH56K0T99EEM7RAj/hSZk3bISeFhuXs7xBBxKQaeLR0QnQpyou5ya4NyyPFXdyvoywqit4J2MYKYrCAGK4gTmtCEJjShCU1oDBK8ktZrBVK80tZrBWLEs8jmawWiCiBKtl8fvbxLIOSglSkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f374.png
// module id = 737
// module chunks = 0